import React, { useContext, useEffect, useState } from 'react';
import { getBankStatementMeataData } from '../../../constants/bank-statement-api';
import CircularProgress from '@material-ui/core/CircularProgress';
import { getAuthToken } from '../../../utils/cookie-utils';
import { LeadData } from '../../UploadedBankStatements/ManullyAddBankStaatements/ManuallyAddBankStatement';
const BankAccountDetails = ({ url }) => {
  const leadDetails = useContext(LeadData);
  const [metaData, setMetaData] = useState({});
  const [loading, setLoading] = useState(true);

  const getMetadata = async () => {
    setLoading(true);
    let body = {
      url: url,
      token: getAuthToken(),
      lead_id: leadDetails?.leadId
    };
    getBankStatementMeataData(body)
      .then(res => {
        setLoading(false);
        let json_data;
        try {
          json_data = JSON.parse(res?.replace(/\bNaN\b/g, null));
        } catch (e) {
          json_data = res;
        }
        const data = json_data?.account_meta_data;
        if (typeof data != 'object') return setMetaData({});
        let not_null_values = Object.keys(data || {}).filter(
          each => data?.[each]
        );
        let get_valid_data = {};
        not_null_values.map(each => {
          get_valid_data[each] = data[each];
        });
        setMetaData(get_valid_data);
      })
      .catch(error => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getMetadata();
  }, []);
  return (
    <div className="w-full">
      <div
        className="w-full mt-5 bg-white py-3 px-3 rounded"
        style={{ minHeight: '250px' }}
      >
        <p className="text-lg text-black-500 mb-3 font-bold">
          Bank Account Details
        </p>
        <hr className="w-full " style={{ borderColor: '#dee0f0' }} />
        {loading ? (
          <div className="mx-auto table items-center mt-8">
            <CircularProgress />
          </div>
        ) : (
          <div className="grid gap-4 mt-5">
            {Object.keys(metaData, {})?.map((each, index) => (
              <div className="grid grid-cols-2" key={index}>
                <div className="w-full font-roboto font-normal text-black-500">
                  {each}
                  <span className="float-right clear-both mx-6">:</span>
                </div>
                <div
                  className="w-full font-roboto  text-black-500"
                  style={{ fontSize: '13px',fontWeight:400,color:'#3d3b3b' }}
                >
                  {metaData?.[each] || '---'}
                </div>
              </div>
            ))}
          </div>
        )}
        {!loading && Object.keys(metaData || {})?.length == 0 && (
          <p className="w-full font-normal mt-5  mx-auto text-black-500 text-center">
            Unable to show any data!
          </p>
        )}
      </div>
    </div>
  );
};

export default BankAccountDetails;
